import get from 'lodash/get';
import styled from 'styled-components';
import { ButtonProps } from './Button';

// <div style="width: 128px; height: 44px; padding-left: 24px; padding-right: 24px; padding-top: 14px; padding-bottom: 14px; background: #0B5FD9; box-shadow: 0px 4px 10px rgba(2, 87, 251, 0.19); border-radius: 57px; flex-direction: column; justify-content: flex-end; align-items: center; gap: 10px; display: inline-flex">
//   <div style="color: white; font-size: 14px; font-family: Inter; font-weight: 700; line-height: 16px; word-wrap: break-word">Log In</div>
// </div>
export const Root = styled.button<ButtonProps>`
  outline: 0;
  transition: opacity 0.1s;
  border: ${(p) => (p.border ? p.border : '0')};
  color: ${(p) => (p.textColor ? p.theme.colors.general[p.textColor] : p.theme.colors.general.white)};
  font-size: ${(p) => (p.size ? p.theme.font.size[p.size] : p.theme.font.size.xs)};
  padding: 0 ${(p) => p.theme.spacing.sm};
  background-color: ${(p) => (p.color ? p.theme.colors.general[p.color] : p.theme.colors.general.primary)};
  border-radius: ${(p) => (p.radius ? p.theme.radius[p.radius] : p.theme.radius.full)};
  font-weight: ${(p) => (p.weight ? p.theme.font.weight[p.weight] : p.theme.font.weight.semibold)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  height: 40px;
  gap: 8px;
  @media (max-width: ${(p) => p.theme.screen.sm}) : {
    font-size: ${(p) => p.theme.font.size.xs};
  }
  ${(p) => p.shadow && `box-shadow: ${p.theme.shadows.input}`}
  /* Secondary actions are outlined, not filled (one filled primary per view). */
  ${(p) =>
    p.color === 'secondary' &&
    !p.text &&
    !p.ghost &&
    `
    background-color: ${p.theme.colors.general.white};
    color: ${p.theme.colors.general.black};
    border: 1px solid ${p.theme.colors.border.dark};
  `}
  ${(p) =>
    p.disabled &&
    `
    background-color: ${p.theme.colors.general.disabled};
    cursor: not-allowed;
  `};

  ${(p) =>
    p.inline &&
    `
    display: inline-block;
  `};

  ${(p) =>
    !p.disabled &&
    `
    &:hover {
      filter: brightness(0.9);
      cursor: pointer;
    }
  `};

  ${(p) =>
    p.text &&
    `
    color: ${p.color ? get(p.theme.colors.general, p.color) : p.theme.colors.general.textSecondary};
    background-color: transparent;

    &:hover {
      background-color: ${p.theme.colors.grey[10]};
    }
  `};

  ${(p) =>
    p.ghost &&
    `
      color: ${p.color ? get(p.theme.colors.general, p.color) : p.theme.colors.general.textSecondary};
      border-radius: 0;
      background-color: transparent;
      padding: 0;
      text-align: left;
  `};

  ${(p) =>
    p.fullWidth &&
    `
    width: 100%;
  `}
  ${(p) =>
    p.fullWidthBreakpoint &&
    `
    @media (max-width: ${p.theme.screen[p.fullWidthBreakpoint]}) { 
      width: 100%;
     };
  `}
`;

export const Link = styled.button<ButtonProps>`
  padding: 0;
  display: inline-block;
  border-bottom: 1px solid ${(p) => p.theme.colors.general.text};
  cursor: pointer;
  color: ${(p) => (p.color ? p.theme.colors.general[p.color] : p.theme.colors.general.text)};
  font-size: ${(p) => (p.size ? p.theme.font.size[p.size] : p.theme.font.size.sm)};
  font-weight: ${(p) => (p.weight ? p.theme.font.weight[p.weight] : p.theme.font.weight.normal)};
  background-color: transparent;
  border: 0;
`;
